module.exports = __webpack_public_path__ + "static/media/1334 2019.ffbe7645.pdf";